import { pluralize } from '@/utils/pluralize'
import {
  DAY_IN_SECONDS,
  HOUR_IN_SECONDS,
  MINUTE_IN_MILLISECONDS,
  SECOND_IN_MILLISECONDS,
} from '@vaultsfyi/common/constants'
import { fromUnixTimestamp } from '@vaultsfyi/common/utils'
import { useEffect, useState } from 'react'

export function useRelativeTime(timestamp: number | null): string | null {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    if (timestamp === null) return
    const id = setInterval(() => setNow(Date.now()), MINUTE_IN_MILLISECONDS)
    return () => clearInterval(id)
  }, [timestamp])

  if (timestamp === null) return null
  return formatRelativeTime(now, fromUnixTimestamp(timestamp))
}

function formatRelativeTime(now: number, timestamp: number): string {
  const diffMs = Math.max(0, now - timestamp)
  const minutes = Math.floor(diffMs / MINUTE_IN_MILLISECONDS)
  const hours = Math.floor(diffMs / (HOUR_IN_SECONDS * SECOND_IN_MILLISECONDS))
  const days = Math.floor(diffMs / (DAY_IN_SECONDS * SECOND_IN_MILLISECONDS))

  if (minutes < 1) return 'just now'
  if (minutes < 60) return `${minutes} ${pluralize(minutes, 'minute')} ago`
  if (hours < 24) return `${hours} ${pluralize(hours, 'hour')} ago`
  return `${days} ${pluralize(days, 'day')} ago`
}
